var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueplus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2456 29.1553C23.2537 29.1553 29.7456 22.6634 29.7456 14.6553C29.7456 6.64714 23.2537 0.155273 15.2456 0.155273C7.23748 0.155273 0.745605 6.64714 0.745605 14.6553C0.745605 22.6634 7.23748 29.1553 15.2456 29.1553Z",
    fill: "#4339F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4749 14.0509H15.8499V10.4259C15.8499 10.0918 15.5792 9.82178 15.2457 9.82178C14.9122 9.82178 14.6415 10.0918 14.6415 10.4259V14.0509H11.0165C10.683 14.0509 10.4124 14.321 10.4124 14.6551C10.4124 14.9892 10.683 15.2593 11.0165 15.2593H14.6415V18.8843C14.6415 19.2184 14.9122 19.4884 15.2457 19.4884C15.5792 19.4884 15.8499 19.2184 15.8499 18.8843V15.2593H19.4749C19.8084 15.2593 20.079 14.9892 20.079 14.6551C20.079 14.321 19.8084 14.0509 19.4749 14.0509Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueplus);
export default __webpack_public_path__ + "static/media/blueplus.1c391acd0af14900c05a53265ca0bbff.svg";
export { ForwardRef as ReactComponent };